import { render, staticRenderFns } from "./MraRecuperacaoRegTable.vue?vue&type=template&id=517000f1&scoped=true&lang=pug"
import script from "./MraRecuperacaoRegTable.vue?vue&type=script&lang=js"
export * from "./MraRecuperacaoRegTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517000f1",
  null
  
)

export default component.exports